import React from "react";
import ProvisionContent from "../../content/public/ProvisionContent.jsx";

export default function ProvisionFortjanstPage() {
  return <ProvisionContent />;
}
